import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '../Navbar';
import { useI18n } from '../../contexts/I18nContext';
import './Layout.scss';

const Layout = ({ children }) => {
  const { t } = useI18n();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search, location.hash]);

  return (
    <div className="layout">
      <Navbar />
      <main className="main-content">{children}</main>

      <footer className="site-footer">
        <div className="container foot-grid">
          <div className="brand-col">
            <div className="brand">Catoo</div>
            <p className="muted">{t('catoo.footerTagline')}</p>
            <p className="contact-email">{t('catoo.contactEmail')}</p>
            {/* <div className="socials">
              <img src={social1} alt="x" />
              <img src={social2} alt="youtube" />
              <img src={social3} alt="discord" />
            </div> */}
          </div>
          <div className="links">
            <div>
              <h4>{t('catoo.productSection')}</h4>
              <Link to="/ai-tools-workbench">{t('catoo.aiWorkbench')}</Link>
              <Link to="/ai-tools/veo-video-generator">{t('catoo.videoGeneration')}</Link>
              <Link to="/creation-record">{t('catoo.myCreations')}</Link>
            </div>
            <div>
              <h4>{t('catoo.resourcesSection')}</h4>
              <Link to="/showcase">{t('catoo.showcase')}</Link>
              <Link to="/pricing">{t('catoo.pricing')}</Link>
              {/* <span className="disabled-link">{t('catoo.guides')}</span>
              <span className="disabled-link">{t('catoo.community')}</span> */}
            </div>
          <div>
            <h4>{t('catoo.companySection')}</h4>
              {/* <span className="disabled-link">{t('catoo.about')}</span>
              <span className="disabled-link">{t('catoo.careers')}</span>
              <span className="disabled-link">{t('catoo.contact')}</span> */}
              <Link to="/privacy-policy">{t('catoo.privacyPolicy')}</Link>
          </div>
          </div>
        </div>
        <div className="container copyright" style={{ marginTop: '10px', padding: '20px 0' }}>
          <p>{t('catoo.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
